<template>
    <Card
        :title="
            licensedUntil
                ? (description ? description + '-' : '') +
                  $t(
                      isDateStringFuture(licensedUntil)
                          ? 'license.valid'
                          : 'license.expired'
                  )
                : $t('no.x.license', {x: description})
        "
        is-dark
        mode="default">
        <InfoBox
            :mode="
                licensedUntil
                    ? isDateStringFuture(licensedUntil)
                        ? 'success'
                        : 'danger'
                    : 'warning'
            "
            :icon="
                licensedUntil
                    ? isDateStringFuture(licensedUntil)
                        ? 'check'
                        : 'warning'
                    : 'info'
            ">
            <div v-if="!licensedUntil">
                <Translate
                    translation-key="no.x.license.message"
                    :parameter="{description: description}" />
            </div>
            <div v-else-if="isDateStringFuture(licensedUntil)">
                {{
                    $t('license.message', {
                        duration: getDaysLeftByDateString(licensedUntil),
                        datetime:
                            getFormattedDateTimeByDateString(licensedUntil),
                        description: description ? description + '-' : '',
                    })
                }}
            </div>
            <div v-else>
                {{
                    $t('license.expired.at.message', {
                        duration: getDaysLeftByDateString(licensedUntil, false),
                        datetime:
                            getFormattedDateTimeByDateString(licensedUntil),
                        description: description ? description + '-' : '',
                    })
                }}
            </div>
        </InfoBox>

        <span v-if="licenseLink">
            <div class="uk-margin-medium-bottom" />
            <a target="_blank" :href="licenseLink">
                <Button
                    :text="$t('renew.license')"
                    is-large
                    is-max
                    mode="primary" />
            </a>
        </span>
    </Card>
</template>

<script>
import Button from '@/components/generic/Button.vue';
import Card from '@/components/generic/Card.vue';
import InfoBox from '@/components/generic/InfoBox.vue';
import Translate from '@/components/Translate.vue';

export default {
    name: 'License',
    components: {Translate, InfoBox, Card, Button},
    props: {
        title: String,
        licensedUntil: String,
        licenseLink: String,
        description: String,
    },
};
</script>

<style lang="scss" scoped></style>
